import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { PEDAGOGY } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/pedagogy/$id")({
  component: () => <DeptContentForm cfg={PEDAGOGY} id={Route.useParams().id} />,
});
